import { Component } from '@angular/core';
import { GmapsInterfaceComponent } from '../common-theme/gmaps/gmaps-interface/gmaps-interface.component';

@Component({
  selector: 'app-interface',
  templateUrl: './interface.component.html',
  styleUrls: ['./interface.component.scss']
})

export class InterfaceComponent extends GmapsInterfaceComponent { }



// WEBPACK FOOTER //
// ./src/app/localisation/interface.component.ts